import React from 'react';
import { NavLink } from 'react-router-dom';

const ShowUsers = ({users}) => {
    return (
        <div 
        className="grid grid-cols-1 gap-4 sm:grid-cols-2"
        style={{
            maxHeight: '75vh',
            overflow: 'auto',
            padding: 5
            }}
        >
        {users?.map((user, index) => (
          <NavLink
          key={index}
          exact
          to={'/user/' + user.id}
          style ={{textDecoration:'none'}}
          >
            <div
              className="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
            >
              {/* <div className="flex-shrink-0">
                <img className="h-10 w-10 rounded-full" src={user.imageUrl} alt="" />
              </div> */}
              <div className="flex-1 min-w-0">
                  <span className="absolute inset-0" aria-hidden="true" />
                  <p className="text-sm font-medium text-gray-900">{user.firstName} {user.lastName}</p>
                  <p className="text-sm text-gray-500 truncate">{user.email}</p>
                  <p className="text-sm text-gray-500 truncate">{user.company}</p>
                  <p className="text-sm text-gray-500 truncate">{user.id}</p>
              </div>
            </div>
          </NavLink>
        ))}
      </div>
    )
}

export default ShowUsers